<template>
  <div class="main">
    <PageHeader/>
       <div class="content">
               <div class="contentsection radio-section">
           <div class="unity-container" id="unity-container">

             <iframe frameborder="0" src="https://itch.io/embed-upload/19267559?color=182323" allowfullscreen="" width="1200px" height="500px"><a href="https://megahammer-studios.itch.io/radio">Play Megahammer Studios Radio on itch.io</a></iframe>
           </div>
         </div>
      <div class="videosection">
        <div class="videosection-content">
          <div class="video-player" :class="{hidden: playerhidden}" ref="player">

<vue-plyr ref="plyr">
  <div class="plyr__video-embed">
    <iframe
      src="https://www.youtube.com/embed/vafxLTNckzw?modestbranding=1&rel=0&playsinline=1&enablejsapi=1"
      allowfullscreen
      allowtransparency
      allow="autoplay"
      loading="lazy"
    ></iframe>
  </div>
</vue-plyr>


          </div>
        </div>
      </div>



      <div class="contentsection">




        <div class="about">

          
          <div class="about-row">
            <div>
              <img src="./assets/DonovanHeadshot_1000x1000.jpg" class="about-image">
            </div>
            <div class="text">
Donovan Jonk is a multi-instrumentalist, composer, and sound designer specializing in game audio. Operating under Megahammer Studios, he crafts unique sonic identities for each project he undertakes. Whether scoring a dramatic cutscene, designing an otherworldly ambience, or implementing an adaptive music system, Donovan ensures a seamless integration of audio that leaves a lasting impact on players.
            </div>
        </div>

        </div>
      </div>

      <!-- CLIENT PROJECTS Section -->
      <div class="title">CLIENT PROJECTS</div>
      
       <div class="bgsection">

        <div class="project-list">
          <div class="project" v-for="project in projects" :key="project.link">
            <div class="project-inner">
              <a :href="project.link" target="_blank">
                <img :src="project.image" class="project-image" />
              </a>
              <div class="project-inner-overlay">
                {{ project.text }}
              </div>
            </div>
            <div class="project-title">{{ project.name }}</div>
          </div>
        </div>

        <!-- Testimonial Section -->
        <div class="title">TESTIMONIALS</div>

        <div class="testimonial-section">
          <div class="testimonial" v-for="testimonial in testimonials" :key="testimonial.name">
            <div class="testimonial-text">{{ testimonial.text }}</div>
            <div class="testimonial-author">{{ testimonial.author }}</div>
            <div class="testimonial-job">{{ testimonial.jobTitle }}</div>
          </div>
        </div>
      </div>
         
        <div class="title">OTHER FUN STUFF</div>

        <div class="project-list">
          <div class="project" v-for="project in other_fun_stuff" :key="project.link">
            <div class="project-inner">
              <a :href="project.link" target="_blank">
                <img :src="project.image" class="project-image" />
              </a>
              <div class="project-inner-overlay">
                {{ project.text }}
              </div>
            </div>
            <div class="project-title">{{ project.name }}</div>
          </div>
        </div>

      <div class="contentsection">
        <div class="title">CONTACT</div>

        <form class="contact-form" method="POST" data-netlify="true"
              data-netlify-honeypot="bot-field" name="contact-form">
          <input type="hidden" name="form-name" value="contact-form" />
          <div class="input-row">
            <div class="col">
              <div class="label">First Name:</div>
              <div class="input-row">
                <input v-model="name" class="input input-name" name="name"/>
              </div>
            </div>
            <div class="col">
              <div class="label">Surname:</div>
              <div class="input-row">
              <input v-model="surname" class="input input-surname" name="surname"/>
              </div>
            </div>
          </div>
          <div class="label">Email:</div>
          <input v-model="email" class="input input-email" name="email"/>
          <div class="label">Subject:</div>
          <input v-model="subject" class="input input-subject" name="subject"/>
          <div class="label">Message:</div>
          <textarea v-model="message" class="input input-message" name="message"/>

          <div class="field">
            <div data-netlify-recaptcha="true"></div>
          </div>

          <div class="button-row">
            <input type="submit" value="SUBMIT" class="submit-button">
          </div>
        </form>
      </div>

      <div class="footer">
        <div class="socials">
           <a href="https://bsky.app/profile/megahammerstudios.com">
            <img src="./assets/bluesky.png"/>
          </a>
          <a href="https://www.instagram.com/megahammerstudios/">
            <img src="./assets/instagram.png"/>
          </a>
          <a href="https://www.youtube.com/channel/UCGbR_xC94Z0zsNQtgOMziqQ">
            <img src="./assets/youtube.png"/>
          </a>
        </div>

      </div>

    </div>
  </div>
</template>


<script>

import PageHeader from "@/components/PageHeader";

export default {
  name: 'App',
  components: {PageHeader},
  data() {
    return {
      name: "",
      surname: "",
      email: "",
      subject: "",
      message: "",
      projects: [
        {
          image: require("./assets/projects/LittleRocketLab_960x540.png"),
          text: "music + sound design",
          link: "https://store.steampowered.com/app/2451100/Little_Rocket_Lab/",
          name: "Little Rocket Lab"
        },
        {
          image: require("./assets/projects/Ultrapool16x9.png"),
          text: "music + sound design",
          link: "https://store.steampowered.com/app/4195110/Ultrapool/",
          name: "Ultrapool"
        },
        {
          image: require("./assets/projects/KaijuWars_960x540.png"),
          text: "sound design",
          link: "https://store.steampowered.com/app/1508400/Kaiju_Wars/",
          name: "Kaiju Wars"
        },
        {
          image: require("./assets/projects/SongsOfSyx_960x540.png"),
          text: "sound design",
          link: "https://store.steampowered.com/app/1162750/Songs_of_Syx/",
          name: "Songs of Syx"
        },
        {
          image: require("./assets/projects/GobsAndGears_960x540.png"),
          text: "music + sound design",
          link: "https://store.steampowered.com/app/4666890/Gobs__Gears/",
          name: "Gobs & Gears"
        },
                {
          image: require("./assets/projects/TicCardToe_960x540.png"),
          text: "sound design",
          link: "https://store.steampowered.com/app/4031860/Tic_Card_Toe/",
          name: "Tic Card Toe"
        },
        {
          image: require("./assets/projects/1BSpells_960x540.png"),
          text: "music + sound design",
          link: "https://store.steampowered.com/app/2390410/1B_Spells/",
          name: "1B Spells"
        },
        {
          image: require("./assets/projects/Battleplan_960x540.png"),
          text: "music + sound design",
          link: "https://store.steampowered.com/app/3743140/Battleplan/",
          name: "Battleplan"
        },
        {
          image: require("./assets/projects/Constellations_960x540.png"),
          text: "music + sound design",
          link: "https://store.steampowered.com/app/1819520/Constellations_Puzzles_in_the_Sky/",
          name: "Constellations"
        },
        {
          image: require("./assets/projects/MushroomPicnicParty_960x540.png"),
          text: "music + sound design",
          link: "https://store.steampowered.com/app/2469280/Mushroom_Picnic_Party/",
          name: "Mushroom Picnic Party"
        },
        {
          image: require("./assets/projects/ChickenJourney_960x540.png"),
          text: "music + sound design",
          link: "https://store.steampowered.com/app/1837650/Chicken_Journey/",
          name: "Chicken Journey"
        },
        {
          image: require("./assets/projects/RealTimeGeneral_960x540.png"),
          text: "music + sound design",
          link: "https://realtimegeneral.com//",
          name: "Real-Time General"
        },
        {
          image: require("./assets/projects/FortuneAndGlory_960x540.png"),
          text: "music + sound design",
          link: "https://store.steampowered.com/app/3022910/Fortune_and_Glory/",
          name: "Fortune & Glory"
        },
        {
          image: require("./assets/projects/BloodNova_960x540.png"),
          text: "music",
          link: "https://store.steampowered.com/app/1810270/Blood_Nova/",
          name: "Blood Nova"
        },
        {
          image: require("./assets/projects/PowerFistDefenceForce_960x540.png"),
          text: "music + sound design",
          link: "https://zenfri.ca/our-projects/",
          name: "Powerfist Defence Force"
        },
        {
          image: require("./assets/projects/TurtleIslandSkateJam_960x540.png"),
          text: "sound design",
          link: "https://www.cbc.ca/kids/games/all/turtle-island-skate-jam",
          name: "Turtle Island Skate Jam - CBC Kids"
        },
        {
          image: require("./assets/projects/3SistersVR_960x540.png"),
          text: "music + sound design",
          link: "https://zenfri.ca/our-projects/",
          name: "Three Sisters VR"
        },
        {
          image: require("./assets/projects/ChiefswoodPark_960x540.png"),
          text: "sound design",
          link: "https://zenfri.ca/our-projects/",
          name: "Chiefswood Park AR"
        },
        {
          image: require("./assets/projects/AnangGiiPiidagoojin_701x394.png"),
          text: "Ambisonic sound design",
          link: "https://zenfri.ca/our-projects/",
          name: "Anang Gii-Piidagoojin AR Tour"
        },
        {
          image: require("./assets/projects/ManoominRootsAndRoutesVR_351x198.png"),
          text: "sound design",
          link: "https://zenfri.ca/our-projects/",
          name: "Manoomin Roots & Routes VR"
        },
        {
          image: require("./assets/projects/NeonHeartsCity_960x540.png"),
          text: "voiceover post-production",
          link: "https://store.steampowered.com/app/3316640/Neon_Hearts_City/",
          name: "Neon Hearts City"
        },
        {
          image: require("./assets/projects/YCSEAO+_960x540.png"),
          text: "music + sound design",
          link: "https://sebastianscaini.itch.io/ycseao-plus",
          name: "YCSEAO+"
        },
        {
          image: require("./assets/projects/FancyTrash_960x540.png"),
          text: "music + sound design",
          link: "https://sebastianscaini.itch.io/fancy-trash",
          name: "Fancy Trash"
        },
        {
          image: require("./assets/projects/BrandinsButtons_960x540.png"),
          text: "music",
          link: "https://store.steampowered.com/app/1480970/Brandins_Buttons/",
          name: "Brandin's Buttons"
        },
      ],
            
      testimonials: [
        {
          text: "Donovan's music and sound design has really brought Little Rocket Lab to life. He's been able to take a collection of ideas and themes and turn it into a fantastic score that really conveys the mood of the game. I couldn't be happier with the end result.",
          author: "Kyle Schmitz - Teenage Astronauts",
          jobTitle: "Little Rocket Lab"
        },
        {
          text: "Working with Donovan was one of the genuine pleasures of building Gobs & Gears. He reached into my brain, pulled out all the goblin-y gooey goodness within and turned it into a fantastical goblin score. Go bother him!",
            author: "The Goblin King - Goblintek",
            jobTitle: "Gobs & Gears"
        },
        {
          text: "Donovan is very talented and skilled in both music and audio design. He always has unexpected ideas that exceed all expectations. Most importantly, though, he's an exceptional human being who's wonderful to work with.",
          author: "Marcin Świderski - Loonyware",
          jobTitle: "Chicken Journey, Mushroom Picnic Party"
        },
        {
        text: "Donovan is not only talented but exceedingly professional. Whenever I work with him, I always know he’s got our back, even if something comes up in the 11th hour. I can’t recommend working with him more highly.",
        author: "Corey King - ZenFri",
        jobTitle: "Powerfist Defence Force, Turtle Island Skate Jam, Three Sisters VR, Chiefswood Park AR"
        }
        ],
            
      other_fun_stuff: [
       {
          image: require("./assets/projects/Bandcamp_960x540.png"),
          text: "bandcamp",
          link: "https://megahammerstudios.bandcamp.com/",
          name: "Official Soundtracks + Original Music"
        },
        {
          image: require("./assets/projects/8BitBundleVol1_960x540.png"),
          text: "music + sfx asset bundle",
          link: "https://megahammer-studios.itch.io/8-bit-music-and-sfx-megahammer-studios-vol-1",
          name: "8-Bit Music + SFX Asset Bundle"
        },
        {
          image: require("./assets/projects/ChickenJourneyDeepDive_960x540.png"),
          text: "watch on youtube",
          link: "https://www.youtube.com/watch?v=xiSx9jo6F6w",
          name: "Chicken Journey Audio Deep Dive"
        },
        {
        image: require("./assets/projects/GuitarForYoungstersPrimerLevel_960x540.png"),
        text: "music education - coming soon",
        name: "Guitar For Youngsters - Guitar Course"
        },
        {
          image: require("./assets/projects/Dragonsphere_960x540.png"),
          text: "classic game tribute project",
          link: "https://www.youtube.com/watch?v=AQlSjyRxFts",
          name: "DragonSphere OST Project"
        },
        {
          image: require("./assets/projects/MassiveCorporationGameStudios_960x540.png"),
          text: "logo sound design",
          link: "http://massivecorp.ca/",
          name: "Massive Corporation Logo SFX"
        },
        {
          image: require("./assets/projects/LiveStreamArchive_960x540.png"),
          text: "livestream collaborations: art, music, sound design",
          link: "https://www.youtube.com/watch?v=vvOvTafi2MU&list=PL2L2NIX4GhktouJQHZFtAcNkJdYjaDSv7&index=1",
          name: "Megahammer A/V Club - Livestreams"
        },
         {
          image: require("./assets/projects/AVeryCheekyValentine_960x540.png"),
          text: "music + sound design licensing",
          link: "http://www.cheekynauts.com/cheeky_valentine/story_html5.html",
          name: "A Very Cheekynauts Valentine"
        }
      ]
    }
  },
  mounted() {



  },
  methods: {
    onClickMonke() {
      this.playerhidden = false;
    },
    videoEnded() {
      this.$refs.plyr.player.restart();
      this.$refs.plyr.player.stop();
    }
  }
}
</script>

<style>
@font-face {
  font-family: "CardenioModernRegular";
  src: url('./assets/CardenioModern-Regular.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
#app {
  font-family: CardenioModernRegular, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  margin: 0;
  height: 100vh;
  width: 100%;

  display: flex;
  flex-direction: column;
}

body {
  margin: 0;
  background-color: black;
}

.testimonial.title {
  padding-bottom: 32px;
  padding-top: 32px;
}
.testimonial-section {
  padding: 16px;
  margin-bottom: 16px;
  background-color: #222222;
  color: #EEEEEE;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
}

.testimonial {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
  max-width: 1200px;
}

.testimonial-text {
  font-style: italic;
  color: #CCCCCC;
  font-size: 26px;
  margin-bottom: 8px;
  text-align: center;
}

.testimonial-author {
  text-align: right;
  font-weight: bold;
  font-size: 20px;
  color: #FFFFFF;
  margin-top: 8px;
}

.testimonial-job {
  text-align: center;
  font-size: 22px;
  color: #999999;
}

.main {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-x: clip;
}

.logo-monke {
  max-width: 100%;
  position: absolute;
  z-index: 400;
}

.text {
  color: #AAAAAA;
  font-size: 30px;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-image: url("./assets/hammerpattern.png");
  background-attachment: fixed;
  background-position: center;
  background-repeat: repeat;
  background-size: 100px;
}

.videosection {
  margin-top: 96px;
  padding: 32px 0;
  width: 100%;
  position: relative;
}

.videosection-content {
  padding: 32px;
  padding-top: 64px;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.contentsection {
  width: 100%;
  background-color: #222222;
  min-height: 300px;
  color: #EEEEEE;
  box-shadow: 0px 10px 15px -3px rgba(0,0,0,0.3);
}

.bgsection {
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer {
  width: 100%;
  height: 150px;
  background-color: #050505;
}

.about {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  color: white;
  font-size: 44px;
  padding-top: 52px;
  font-weight: bold;
}

.about .text {
  text-align: left;
  max-width: 800px;
  padding-right: 64px;
}

.about-row {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 32px;
  min-height: 300px;
}

.about-image {
  max-width: 250px;
  border-radius: 1000px;
  padding: 32px;
}

.video-player {
  width: 100%;
  max-width: 1000px;
  transition: 0.5s;
  margin-top: -40px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0px 10px 15px -3px rgba(0,0,0,0.3);
}

.project-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  max-width: 80%;
  padding-bottom: 32px;
  padding-top: 32px;
}

.project {
  padding: 32px;
}

.project-inner {
  background-color: #111111;
  width: 300px;
  height: 170px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0px 10px 15px -3px rgba(0,0,0,0.3);
  position: relative;
}

.project-image {
  width: 300px;
}

.project-title {
  padding-top: 12px;
  color: white;
  font-weight: bold;
  font-size: 20px;
}

.project-inner-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: transparent;
  color: transparent;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  transition: 0.2s;
  font-weight: bold;
  font-size: 28px;
}

.project-inner:hover .project-inner-overlay {
  background-color: #000000AA;
  color: white;
}

.contact-form {
  display: flex;
  flex-direction: column;
  padding: 20px 20% 100px 20%;
}

.input-row {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.contact-form .input {
  padding: 8px;
  border-radius: 8px;
  border: none !important;
  margin: 8px;
  flex-grow: 1;
}

textarea.input {
  height: 100px;
  resize: none;
}

input {
  border: none;
  outline: none;
}

textarea {
  outline: none;
}

input:focus {
  border: none;
  outline: none;
}

.button-row {
  display: flex;
  justify-content: end;
}

.submit-button {
  padding: 12px;
  margin-top: 8px;
  margin-right: 8px;
  font-weight: bold;
  font-size: 20px;
  background-color: #111111;
  color: #CCCCCC;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.col {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: start;
}

.label {
  font-weight: bold;
  padding-left: 8px;
  text-align: left;
}

.socials {
  padding-top: 32px;
}

.socials img {
  height: 32px;
  padding: 8px;
  opacity: 0.6;
  transition: 0.2s;
}

.socials img:hover {
  opacity: 1;
}

@media only screen and (max-width: 800px) {
  .about-row {
    flex-direction: column;
  }

  .about-image {
    padding: 32px;
  }

  .about .text {
    padding: 32px;
  }
}

@media only screen and (max-width: 600px) {
  .about .text {
    font-size: 20px;
  }

  .input-row {
    flex-direction: column;
  }

  .contact-form {
    padding: 32px;
  }
}

.unity-container {
  position: relative;
  width: 100%;
  height: 500px;
  overflow: hidden;
}

.unity-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.radio-section {
  position: sticky;
  top: -220px;
  z-index: 999;
  background-color: #000000;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.3);
  margin-top: 192px;
}

#unity-blocker {
  position: absolute;
  width: 100vw;
  height: 40vw;
  top: 0;
  left: 0;
  z-index: 10;
  pointer-events: all;
}

iframe {
  overflow: hidden;
}

@media only screen and (max-width: 1200px) {
  .radio-section {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
.videosection {
  height: auto;
  padding: 16px 0;
  margin-top: 100px;
}

.videosection-content {
  padding: 16px;
  padding-top: 32px;
  flex-direction: column;
}
.video-player {
  margin-top: 0;
}
}
</style>




